<template>
  <responsive-drawer-header :hasDrawer="isNotDetailPage" :color="theme.appBar.other.color" :moduleUnreadCount="0">
    <template v-slot:drawer-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>
      <div>{{ nameOrPageTitle }}</div>
    </template>
    <!-- left container -->
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>employeeId{{ employeeId }}{{ nameOrPageTitle }}</template>
    <template v-if="isNotDetailPage" v-slot:left-subtitle>
      <div v-if="isLoaded">{{ name }}</div>
      <div v-else>loading</div>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import { ROUTE_EMPLOYEE_OVERVIEW } from '@/modules/employee/routes';

export default {
  name: 'EmployeeHeader',

  mixins: [common, configMixin],
  components: {
    ResponsiveDrawerHeader,
  },
  data() {
    return {};
  },

  computed: {
    ...mapState('employee', ['isLoaded', 'personItemById']),
    employeeId() {
      return this.$route.params.employeeId;
    },
    routeName() {
      return this.$route.name;
    },
    person() {
      return this.personItemById[this.employeeId];
    },

    name() {
      return this.person ? this.person.name : '';
    },

    nameOrPageTitle() {
      return this.routeName === ROUTE_EMPLOYEE_OVERVIEW ? this.$t('employeeOverview') : this.name;
    },
    isNotDetailPage() {
      return this.routeName === ROUTE_EMPLOYEE_OVERVIEW;
    },
  },
};
</script>
